import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, reactive, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  currentName: {
    type: String,
    required: true
  }
},
  emits: ["cancel", "validate"],
  setup(__props, { emit }) {

const props = __props




const state = reactive({
  isOpen: computed(() => props.isOpen)
});

const newName = ref(props.currentName);

const isValid = computed(() => {
  const trimmed = newName.value.trim();
  return trimmed.length >= 2 && trimmed.length <= 100 && trimmed !== props.currentName.trim();
});

watch(() => props.currentName, (name) => {
  newName.value = name;
});

watch(() => props.isOpen, (open) => {
  if (open) {
    newName.value = props.currentName;
  }
});

function onSave() {
  if (isValid.value) {
    emit("validate", newName.value.trim());
  }
}

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createBlock(_component_va_modal, {
    modelValue: _unref(state).isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(state).isOpen = $event)),
    "hide-default-actions": "",
    title: _ctx.$t('organizations.editModal.title')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_va_button, {
        flat: "",
        outline: "",
        class: "mr-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_va_button, {
        class: "ml-1",
        color: "success",
        disabled: !_unref(isValid),
        onClick: onSave
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("organizations.editModal.save")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_va_input, {
        modelValue: newName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (newName.value = $event)),
        label: _ctx.$t('organizations.editModal.label'),
        placeholder: _ctx.$t('organizations.editModal.placeholder'),
        hint: _ctx.$t('organizations.editModal.currentName', { name: props.currentName }),
        class: "input-name"
      }, null, 8, ["modelValue", "label", "placeholder", "hint"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})